import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import heroLogo from '../assets/hero_logo.png';
import './Header.css';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const isActive = (path) => {
        return location.pathname === path ? 'active' : '';
    };

    return (
        <header className="header">
            <div className="container header-container">
                <div className="logo">
                    <Link to="/" onClick={closeMenu}>
                        <img src={heroLogo} alt="P&C Property Management" className="header-logo" />
                    </Link>
                </div>

                <button className="mobile-menu-btn" onClick={toggleMenu} aria-label="Toggle navigation">
                    <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
                </button>

                <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
                    <ul>
                        <li>
                            <Link to="/" className={isActive('/')} onClick={closeMenu}>Home</Link>
                        </li>
                        <li>
                            <Link to="/properties" className={isActive('/properties')} onClick={closeMenu}>Properties</Link>
                        </li>
                        <li>
                            <Link to="/services" className={isActive('/services')} onClick={closeMenu}>Services</Link>
                        </li>
                        <li>
                            <Link to="/tenants" className={isActive('/tenants')} onClick={closeMenu}>Tenants & Resources</Link>
                        </li>
                        <li>
                            <Link to="/contact" className={isActive('/contact')} onClick={closeMenu}>Contact</Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header;
